import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Actions
import {
    requestLoadTimesheetEntries,
    canceledLoadTimesheetEntries
} from '../../../../../../services/timesheetEntries/actions';

// Selectors
import { selectLoadTimesheetEntriesParams } from '../../../../../../services/timesheetEntries/selectors';

interface Props {
    loadTimesheetEntriesParams?: Record<string, any>;
    requestLoadTimesheetEntries: Function;
    canceledLoadTimesheetEntries: Function;
}

export class TimesheetEntriesRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.requestLoadTimesheetEntries();
    }

    componentDidUpdate(prevProps: Props) {
        if (
            !isEqual(
                prevProps.loadTimesheetEntriesParams,
                this.props.loadTimesheetEntriesParams
            )
        ) {
            this.props.requestLoadTimesheetEntries();
        }
    }

    componentWillUnmount() {
        this.props.canceledLoadTimesheetEntries();
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    loadTimesheetEntriesParams: selectLoadTimesheetEntriesParams
});

export default connect(
    mapStateToProps,
    {
        requestLoadTimesheetEntries,
        canceledLoadTimesheetEntries
    }
)(TimesheetEntriesRequest);
